import axios from 'axios';
import { apiMainUrl } from '../apiConfig';
import { normalizeAppRole, normalizeRolePermissionSet } from '../Models/SecurityModels';

const API_URL = `${apiMainUrl}roles`;
const authConfig = token => ({ headers: { Authorization: `Bearer ${token}` } });

const getRoles = async (accessToken, includeInactive = true) => {
    const response = await axios.get(API_URL, {
        ...authConfig(accessToken),
        params: { includeInactive }
    });
    return response.data.map(normalizeAppRole);
};

const getRole = async (roleId, accessToken) => {
    const response = await axios.get(`${API_URL}/${roleId}`, authConfig(accessToken));
    return normalizeAppRole(response.data);
};

const createRole = async (roleName, accessToken) => {
    const response = await axios.post(API_URL, { roleName }, authConfig(accessToken));
    return normalizeAppRole(response.data);
};

const updateRole = async (roleId, roleName, accessToken) => {
    const response = await axios.put(`${API_URL}/${roleId}`, { roleName }, authConfig(accessToken));
    return normalizeAppRole(response.data);
};

const setRoleStatus = async (roleId, isActive, accessToken) => {
    const response = await axios.patch(
        `${API_URL}/${roleId}/status`,
        { isActive },
        authConfig(accessToken)
    );
    return normalizeAppRole(response.data);
};

const getRolePermissions = async (roleId, accessToken) => {
    const response = await axios.get(`${API_URL}/${roleId}/permissions`, authConfig(accessToken));
    return normalizeRolePermissionSet(response.data);
};

const replaceRolePermissions = async (roleId, permissions, accessToken) => {
    const response = await axios.put(
        `${API_URL}/${roleId}/permissions`,
        { permissions },
        authConfig(accessToken)
    );
    return normalizeRolePermissionSet(response.data);
};

export const RolesDataService = {
    getRoles,
    getRole,
    createRole,
    updateRole,
    setRoleStatus,
    getRolePermissions,
    replaceRolePermissions
};
